import React from 'react';
import PropTypes from 'prop-types';
import {
  ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, Label, Cell, ResponsiveContainer
} from 'recharts';
import { scaleQuantile } from 'd3-scale';
import { schemeBuPu } from 'd3-scale-chromatic';
import { ascending } from 'd3-array';
import LegendQuantile from '../Legend/Quantile';
import { round } from '../helper';
import BubbleData from '../data/RideshareAgeDensityGreaterBoston.json';
import './Bubble.css';

// get an array of just the y property values
const pct1824Array = BubbleData.map((item) => item.PCT_18_24);
pct1824Array.sort(ascending);

const colorScale = scaleQuantile()
  .domain(pct1824Array)
  .range(schemeBuPu[7]);


const CustomTooltip = (props) => {
  const { active } = props;
  if (active) {
    const { payload } = props;
    const payloadAll = payload[0].payload;
    const { TOWN, PCT_18_24 } = payloadAll;
    return(
      <div className="tooltip">
        <p className="label"><b>{`${TOWN}`}</b></p>
        <hr />
        {
          payload.map((dataKey) => {
            const { name, value, unit } = dataKey;
            return(<p className="">{`${name}: ${round(value, 2)}${unit}`}</p>);
          })
        }
        <p className="">{`Percentage of Age 18-24: ${round(PCT_18_24, 0)}%`}</p>
      </div>
    );
  } return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array
};

const Bubble = () => (
  <div className="bubble">
    <ResponsiveContainer width="100%" height={500}>
      <ScatterChart
        margin={{
          top: 20, right: 0, bottom: 25, left: 15
        }}
        onClick={null}
      >
        <XAxis type="number" dataKey="POP_PER_SQ_MILE" name="Population Density" unit="">
          <Label value="Population Density (per sq. mile)" offset={[0, 10]} position="bottom" />
        </XAxis>
        <YAxis type="number" dataKey="ORIGIN_TRIPS_PER_PERSON" name="Trips Started Per Person">
          <Label value="Trips Started Per Person" textAnchor="middle" angle={-90} position="insideLeft" />
        </YAxis>
        <CartesianGrid />
        <Tooltip cursor={{ strokeDasharray: '3 3' }} content={<CustomTooltip />} />
        <Scatter name="Correlation Between Age, Population Density and Rideshare Trips" data={BubbleData} shape="circle">
          {BubbleData.map((entry, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Cell key={`cell-${index}`} stroke="#555" fill={colorScale(+entry.PCT_18_24)} opacity={0.9} size={200} />
          ))}
        </Scatter>
      </ScatterChart>
    </ResponsiveContainer>

    <div className="bubble-legend bubble-legend--left">
      <div className="recharts-label">Pecentage of Age 18–24</div>
      <hr />
      <LegendQuantile
        scale={colorScale}
        direction="column"
        labelMargin="0 5px 0 0"
        shape="circle"
        labelFormat={(d) => `${round(d, 0)}%`}
      />
    </div>
  </div>
);

export default Bubble;
